import { Injectable } from '@angular/core';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { API_URL } from '../../../../../services/config';
import { UserEndpoint } from '../constants/user-endpoint';
import { UserModel, UserRolesModel } from '../models';
import { UserOwnerType } from '../constants';
import { Role } from '../../../../../common/constants';

@Injectable({
  providedIn: 'root',
})
export class UserItemService {
  constructor(private http: WrapperHttpService) {}

  getUserDetails(userId: string): Observable<UserModel> {
    return this.http.withLoading().get<UserModel>(`${API_URL}${UserEndpoint.Base}/${userId}`);
  }

  getUserRoleList(target: UserOwnerType): Observable<UserRolesModel> {
    if (target) {
      return this.http
        .withLoading()
        .get<UserRolesModel>(`${API_URL}${UserEndpoint.Base}${UserEndpoint.Roles}?owner=${target}`);
    } else {
      return this.http.withLoading().get<UserRolesModel>(`${API_URL}${UserEndpoint.Base}${UserEndpoint.Roles}`);
    }
  }
  isEmailExist(email: string): Observable<boolean> {
    return this.http.withLoading().get<boolean>(`${API_URL}${UserEndpoint.Base}${UserEndpoint.Exists}?email=${email}`);
  }

  isEmailExistInActiveDirectory(email: string): Observable<boolean> {
    return this.http
      .withLoading()
      .get(`${API_URL}${UserEndpoint.MicroSoft}${UserEndpoint.ActiveDirectory}${UserEndpoint.Exists}?email=${email}`);
  }
  approveUser(userId: string, role: Role[]): Observable<UserModel> {
    return this.http
      .withLoading()
      .post<UserModel>(`${API_URL}${UserEndpoint.Base}/${userId}${UserEndpoint.Approve}`, role);
  }

  createUser(body: UserModel): Observable<UserModel> {
    return this.http.withLoading().post<UserModel>(`${API_URL}${UserEndpoint.Base}`, body);
  }

  resetUserPassword(userId: string): Observable<unknown> {
    return this.http
      .withLoading()
      .get(`${API_URL}${UserEndpoint.Base}/${userId}${UserEndpoint.Password}${UserEndpoint.Reset}`, {});
  }

  updateUser(body: UserModel): Observable<UserModel> {
    return this.http.withLoading().post<UserModel>(`${API_URL}${UserEndpoint.Base}`, body);
  }

  deleteUsers(userIds: number[]): Observable<void> {
    return this.http.withLoading().delete<void>(`${API_URL}${UserEndpoint.Base}`, {
      body: userIds,
    });
  }
}
